export const lowerCaseKeys = (obj) => Object.fromEntries(Object.keys(obj).map((k) => [k.toLowerCase(), obj[k]]));

export const isAllowedByTaxonomyDropdownField = (item, allowedTerms, taxonomyFieldCodename) => {
  const normalizedAllowed = lowerCaseKeys(allowedTerms);

  const taxonomyValues = Array.isArray(item?.elements?.[taxonomyFieldCodename]?.value)
    ? item.elements[taxonomyFieldCodename].value
    : [];

  if (!taxonomyValues.length) return true;

  return taxonomyValues.some((term) => {
    const key = term.name;
    return !!normalizedAllowed[key?.toLowerCase()];
  });
};

export const isAllowedByTaxonomyChecklistField = (item, allowedTerms, taxonomyFieldCodename) => {
  const taxonomyValues = Array.isArray(item?.elements?.[taxonomyFieldCodename]?.value)
    ? item.elements[taxonomyFieldCodename].value
    : [];

  if (!taxonomyValues.length) return true;
  return taxonomyValues.some((term) => term.name.toLowerCase() === allowedTerms.toLowerCase());
};

export const resolveModularElementValue = (raw, response, element) => {
  const normalizedElement = response?.[element];
  if (!normalizedElement) return null;
  const content = {};
  let filteredContent = '';
  let heading = '';
  const linkedItemCodenames = Array.isArray(normalizedElement?.linkedItemCodenames)
    ? normalizedElement.linkedItemCodenames
    : [];

  if ((element === 'content' || element === 'title') && linkedItemCodenames.length === 0) {
    return normalizedElement?.value || '';
  }

  if ((element === 'content' || element === 'title') && linkedItemCodenames.length > 0) {
    content.body = normalizedElement?.value || '';
  }

  if (element === 'change_summary') {
    content[element] = { value: normalizedElement?.value || '', heading: normalizedElement?.name || '' };
  }

  if (element === 'panel_summary') {
    content[element] = { value: normalizedElement?.value || '', heading: normalizedElement?.name || '' };
  }

  linkedItemCodenames.forEach((codename) => {
    filteredContent = raw?.response?.data?.modular_content?.[codename]?.elements?.content_body?.value || '';
    heading = raw?.response?.data?.modular_content?.[codename]?.elements?.heading?.value || '';
    content[codename] = { value: filteredContent, heading };

    if (
      element === 'panel_summary' ||
      element === 'change_summary' ||
      codename === 'contact_method_post' ||
      codename === 'contactmethodemail'
    ) {
      filteredContent = raw?.response?.data?.modular_content?.[codename]?.elements?.content?.value || '';
      heading = raw?.response?.data?.modular_content?.[codename]?.system?.name || '';
      content[codename] = { value: filteredContent, heading };
    }

    const modularContent =
      raw?.response?.data?.modular_content?.[codename]?.elements?.content_body?.modular_content || {};
    if (Object.keys(modularContent).length > 0) {
      modularContent.forEach((modularCodename) => {
        filteredContent = raw?.response?.data?.modular_content?.[modularCodename]?.elements?.content_body?.value || '';
        heading = raw?.response?.data?.modular_content?.[modularCodename]?.elements?.heading?.value || '';
        content[modularCodename] = { value: filteredContent, heading };
      });
    }
  });

  return content ?? null;
};

export const resolveModularTooltipElementValue = (response, element) => {
  const normalizedElement = response?.[element];
  if (!normalizedElement) return null;
  const content = {};
  let filteredContent = '';
  let heading = '';
  let type = '';
  let id = null;
  const linkedItemCodenames = normalizedElement?.linkedItemCodenames || normalizedElement?.value || [];
  linkedItemCodenames.forEach((codename) => {
    filteredContent = normalizedElement?.linkedItems?.[0]?.elements?.body_content?.value || '';
    heading = normalizedElement?.linkedItems?.[0]?.system?.name || '';
    id = normalizedElement?.linkedItems?.[0]?.system?.id || null;
    type = normalizedElement?.linkedItems?.[0]?.system?.type || '';
    content[codename] = { value: filteredContent, heading, id, type };

    const linkedItemContents = normalizedElement?.linkedItems?.[0]?.elements?.content_block_variants?.value || {};
    if (Object.keys(linkedItemContents).length > 0) {
      linkedItemContents.forEach((contentBlockLinkedItemsCodename, index) => {
        filteredContent =
          normalizedElement?.linkedItems?.[0]?.elements?.content_block_variants?.linkedItems?.[index]?.elements
            ?.body_content?.value || '';
        heading =
          normalizedElement?.linkedItems?.[0]?.elements?.content_block_variants?.linkedItems?.[index]?.system?.name ||
          '';
        id =
          normalizedElement?.linkedItems?.[0]?.elements?.content_block_variants?.linkedItems?.[index]?.system?.id ||
          null;
        type =
          normalizedElement?.linkedItems?.[0]?.elements?.content_block_variants?.linkedItems?.[index]?.system?.type ||
          '';
        content[contentBlockLinkedItemsCodename] = { value: filteredContent, heading, id, type };
      });
    }
  });

  return content ?? null;
};

export const resolveGeneralTooltipElementValue = (response, element) => {
  const normalizedElement = response;
  if (!normalizedElement) return null;
  const content = {};
  let filteredContent = '';
  let heading = '';
  let type = '';
  let id = null;
  normalizedElement.forEach((item) => {
    if (item?.system?.codename === element) {
      filteredContent = item?.elements?.tool_tip_text?.value || '';
      heading = item?.system?.name || '';
      id = item?.system?.id || null;
      type = item?.system?.type || '';

      content[element] = { value: filteredContent, heading, id, type };
    }
  });

  return content ?? null;
};
